// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"546":"dd35da01","833":"b7f3d6cb"}[chunkId] + ".chunk.js";
};